import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

export type V_All = {
  '@id': string;
  '@type': 'TagCategory';
  id: string;
  name: string;
};

export function useReadCollectionAll(options?: ReadConfig) {
  return useApiRead<HydraCollection<V_All>>(`/tag-categories/all`, options);
}
